import { render } from "./LocationTabView.vue?vue&type=template&id=fc84d644"
import script from "./LocationTabView.vue?vue&type=script&lang=js"
export * from "./LocationTabView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__